import React from 'react';

class BodyColor extends React.Component {
	componentDidMount() {
		const color = this.getColor();

		if (!color) return;

		this.bodyClass = `bg-${color}`;
		document.body.classList.toggle(this.bodyClass, true);
	}

	componentWillUnmount() {
		// Remove the specific class that was added, and also clean up both possible classes
		// to ensure no background color persists when navigating away
		if (this.bodyClass) {
			document.body.classList.remove(this.bodyClass);
		}
		// Also remove both classes to be safe (in case of race conditions)
		document.body.classList.remove('bg-primary', 'bg-bromma');
	}

	getColor() {
		const { props } = this;

		if (props.primary) return 'primary';
		if (props.bromma) return 'bromma';

		return false;
	}

	render() {
		return null;
	}
}

export default BodyColor;



// WEBPACK FOOTER //
// ./src/components/Common/BodyColor/BodyColor.js